import { render, staticRenderFns } from "./PaidCourseReceive.vue?vue&type=template&id=4c265902"
import script from "./PaidCourseReceive.vue?vue&type=script&lang=js"
export * from "./PaidCourseReceive.vue?vue&type=script&lang=js"
import style0 from "./PaidCourseReceive.vue?vue&type=style&index=0&id=4c265902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports